// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// import ElementUI from 'element-ui'
import {
  Button, Slider, Checkbox, Card, Tooltip, Carousel, Timeline, TimelineItem, InputNumber, Main, RadioButton, Tabs, TabPane, Input, DatePicker, Switch, Progress, Table, TableColumn, Cascader, Image,
  Radio, RadioGroup, Loading, CheckboxGroup, Steps, Step, Form, FormItem, CarouselItem, Dialog, Collapse, CollapseItem, Header, Container,
  Aside, Menu, MenuItem, Submenu, MenuItemGroup, Upload, Footer, Row, Col, Select, OptionGroup, Option
} from 'element-ui';
import ElCollapseTransition from 'element-ui/lib/transitions/collapse-transition';

import VueResource from 'vue-resource';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import VueLazyload from 'vue-lazyload';

import vueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';


import bContainer from 'bootstrap-vue/src/components/layout/container';
// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap-vue/dist/bootstrap-vue.css';

import VueI18n from 'vue-i18n'
import en from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'


import App from './App';
import router from './router';

Vue.config.productionTip = false;

Vue.use(Button);
Vue.use(Slider);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
// Vue.use(MessageBox);
Vue.use(InputNumber);
Vue.use(Card);
Vue.use(Tooltip);
Vue.use(Carousel);
Vue.use(Main);
Vue.use(RadioButton);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Loading);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Cascader);
Vue.use(Image);
Vue.use(Steps);
Vue.use(Step);
Vue.use(CarouselItem);
Vue.use(Header);
Vue.use(Container);
Vue.use(Aside);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Submenu);
Vue.use(MenuItemGroup);
Vue.use(Upload);
Vue.use(Dialog);
Vue.use(Input);
Vue.use(DatePicker);
Vue.use(Footer);
Vue.use(Row);
Vue.use(Col);
Vue.use(Select);
Vue.use(OptionGroup);
Vue.use(Option);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Progress);
Vue.use(Switch);


Vue.component('vue-tel-input', vueTelInput);

Vue.component('el-collapse-transition', ElCollapseTransition);

Vue.component('bContainer', bContainer);

Vue.use(VueResource);

Vue.use(VueI18n);

Vue.use(VueLazyload, {
  // preLoad: 1.3,
  // error: 'dist/error.png',
  // loading: 'dist/loading.gif',
  attempt: 7
})

import Get_Attr_From_HTML from '../src/assets/js/getLang';

// diff language for element-ui
if (Get_Attr_From_HTML('en') == 'en') {
  locale.use(en);
}

const i18n = new VueI18n({
  locale: Get_Attr_From_HTML('en'),
  messages: {
    'zh': require('../lang/zh-hans'),
    'en': require('../lang/en')
  }
})

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  template: '<App/>',
  components: { App },
  router: router,
  data: {
    reservation: {},
    project: '',
    publishableKey: '',
    cities: [],
    lang: document.cookie
  },
  beforeMount() {
    let attr = this.$el.attributes;
    this.previousUrl = attr['previous-url'] && attr['previous-url'].value;
    this.successUrl = attr['success-url'] && attr['success-url'].value;
    this.regionQuery = attr['region-query'] && attr['region-query'].value;
    this.cityRanking = attr['city'] && JSON.parse(attr.city.value);
    this.apiProject = attr['api-project'] && attr['api-project'].value;
    this.apiMapProject = attr['api-map-project'] && attr['api-map-project'].value;
    this.apiRanking = attr['api-ranking'] && attr['api-ranking'].value;
    this.apiRegion = attr['api-region'] && attr['api-region'].value;
    this.apiReservation = attr['api-reservation'] && attr['api-reservation'].value;
    this.unit = attr.unit && attr.unit.value;
    this.currency = attr.currency && attr.currency.value;
    this.regionGroup = attr['region-group'] && JSON.parse(attr['region-group'].value);
    this.cities = attr.cities && JSON.parse(attr.cities.value);
    this.dates = attr.dates && JSON.parse(attr.dates.value);
    this.reservation = attr.reservation && JSON.parse(attr.reservation.value);
    this.project = attr.project && attr.project.value;
    this.publishableKey = attr.publishableKey && attr.publishableKey.value;
    this.apiGeoRegionId = attr['api-geo-region-id'] && attr['api-geo-region-id'].value;
    this.apiJenks = attr['api-jenks'] && JSON.parse(attr['api-jenks'].value);
    this.userId = attr['data-user-id'] && attr['data-user-id'].value;
    this.token = attr['data-token'] && attr['data-token'].value;
    this.ppbApi = attr['data-ppb-api'] && attr['data-ppb-api'].value;
    this.cookie = {
      acreage: Get_Attr_From_HTML("Sq"),
      currency: Get_Attr_From_HTML("Cur"),
    }
  },

  mounted() {
    let csrftoken = this.getCookie('csrftoken');

    Vue.http.interceptors.push(function (request) {
      request.headers.set('X-CSRFToken', csrftoken)
      request.headers.set('X-PPB-Origin', 'WEB')
    });
  },

  methods: {
    getCookie(name) {
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(name) === 0) {
          // name.length + 1: reduce = symbol
          return c.substring(name.length + 1, c.length);
        }
      }
    },

  },

});




// WEBPACK FOOTER //
// ./src/main.js